import Map from 'eemovel-map-library/src/data/google-maps/map';
import { AddAlert } from '@/component';
import Pin from '../../../assets/img/pin-svgrepo-com_1.svg';
import { updateRequestStatusT } from '../realtyTransactions/redux/realtyTransactions.actions';
import { updateRequestStatusSecondary } from '../realtyOffersSecondary/redux/offersSecondary.actions';
import { updateRequestStatus } from '../realtyOffersPrimary/redux/offersPrimary.actions';
import { removePolygons } from '../dataLayers/redux/dataLayers.actions';
import { clearDataLayers } from '../dataLayers/controllers/dataLayers.controller';

export const IS_ACTIVE = 'IS_ACTIVE';
export const setIsActive = (e) => ({
  type: IS_ACTIVE,
  payload: e,
});

export const IS_ACTIVE_RIGHT_SIDEBAR = 'IS_ACTIVE_RIGHT_SIDEBAR';
export const setIsActiveRightSidebar = (e) => ({
  type: IS_ACTIVE_RIGHT_SIDEBAR,
  payload: e,
});

export const MODAL_OPEN = 'MODAL_OPEN';
export const modalOpen = (e) => ({
  type: MODAL_OPEN,
  payload: e,
});

export const modalClose = (e) => ({
  type: MODAL_OPEN,
  payload: '',
});

export const LIST_CITIES = 'LIST_CITIES';
export const setCities = (e) => ({
  type: LIST_CITIES,
  payload: e,
});

export const UPDATE_REALTY_OFFERS_FILTERS = 'UPDATE_REALTY_OFFERS_FILTERS';
export const updateRealtyOffersFilters = (e) => ({
  type: UPDATE_REALTY_OFFERS_FILTERS,
  payload: e,
});

export const UPDATE_CLUSTERS = 'UPDATE_CLUSTERS';
export const updateClusters = (e) => ({
  type: UPDATE_CLUSTERS,
  payload: e,
});

export const SET_DISPLAY_CHARTS = 'SET_DISPLAY_CHARTS';
export const setDisplayCharts = (e) => ({
  type: SET_DISPLAY_CHARTS,
  payload: e,
});

export const REMOVE_CLUSTERS = 'REMOVE_CLUSTERS';
export const removeClusters = (e) => ({
  type: REMOVE_CLUSTERS,
  payload: e,
});

export const REMOVE_MARKERS = 'REMOVE_MARKERS';
export const removeMarkers = (e) => ({
  type: REMOVE_MARKERS,
  payload: e,
});

export const CHANGE_SEARCH = 'CHANGE_SEARCH';
export const changeSearch = (e) => ({
  type: CHANGE_SEARCH,
  payload: e,
});

export const LIST_ADDRESS = 'LIST_ADDRESS';
export const setAddress = (e) => ({
  type: LIST_ADDRESS,
  payload: e,
});

export const SET_MARKET_TYPE = 'SET_MARKET_TYPE';
export const setMarketType = (e) => ({
  type: SET_MARKET_TYPE,
  payload: e,
});

export const UPDATE_MARKERS = 'UPDATE_MARKERS';
export const updateMarkers = (e) => ({
  type: UPDATE_MARKERS,
  payload: e,
});

export const ADD_MARKER = 'ADD_MARKER';
export const addMarker = (e) => ({
  type: ADD_MARKER,
  payload: e,
});

export const UPDATE_INFO_WINDOWS = 'UPDATE_INFO_WINDOWS';
export const updateInfoWindows = (e) => ({
  type: UPDATE_INFO_WINDOWS,
  payload: e,
});

export const ADD_PIN = 'ADD_PIN';
export const addPin = (e) => ({
  type: ADD_PIN,
  payload: e,
});

export const REMOVE_PIN = 'REMOVE_PIN';
export const removePin = (e) => ({
  type: REMOVE_PIN,
  payload: e,
});

export const SET_DISPLAY_STUDY_CREATION_GUIDE =
  'SET_DISPLAY_STUDY_CREATION_GUIDE';
export const setDisplayStudyCreationGuide = (e) => ({
  type: SET_DISPLAY_STUDY_CREATION_GUIDE,
  payload: e,
});

export const erasePin = (pin) => {
  return (dispatch) => {
    if (pin) {
      pin.setMap(null);
    }
    dispatch(removePin());
  };
};

export const closeAllCharts = () => {
  return (dispatch) => {
    dispatch([
      updateRequestStatus({ name: 'launchedUnits', value: 'INACTIVE' }),
      updateRequestStatus({
        name: 'launchedUnitsEcoMapPercentile',
        value: 'INACTIVE',
      }),
      updateRequestStatus({ name: 'sales', value: 'INACTIVE' }),
      updateRequestStatus({ name: 'harvest', value: 'INACTIVE' }),
      updateRequestStatus({ name: 'releasesSalesStock', value: 'INACTIVE' }),
      updateRequestStatus({ name: 'salesEcoMap', value: 'INACTIVE' }),
      updateRequestStatus({
        name: 'releasesSalesStock',
        value: 'INACTIVE',
      }),
      updateRequestStatusSecondary({
        name: 'RealtyOffersByPeriod',
        value: 'INACTIVE',
      }),
      updateRequestStatusSecondary({
        name: 'AnnouncedOverExisting',
        value: 'INACTIVE',
      }),
      updateRequestStatusSecondary({
        name: 'PriceVariationByPeriod',
        value: 'INACTIVE',
      }),
      updateRequestStatus({
        name: 'transactionedOverExistingRealties',
        value: 'INACTIVE',
      }),
      updateRequestStatusT({
        name: 'transactionedOverExistingRealties',
        value: 'INACTIVE',
      }),
      updateRequestStatus({ name: 'weightedAverage', value: 'INACTIVE' }),
      updateRequestStatus({ name: 'weightedAverageEcoMap', value: 'INACTIVE' }),
    ]);
  };
};

export const clearMap = () => {
  return (dispatch) => {
    dispatch([
      erasePin(),
      removeMarkers(),
      removeClusters(),
      removePolygons('neighborhood'),
      removePolygons('zoning'),
      removePolygons('valueZoning'),
      clearDataLayers(),
    ]);
    Map.PoligonOnMap?.setMap(null);
    Map.PoligonOnMap = null;
    Map.markerCircle?.setMap(null);
    Map.markerCircle = null;
    Map.isochronePoligons.forEach((el) => el.setMap(null));
    Map.removePoligons('neighborhood');
    Map.schoolPoligons.forEach((el) => el.setMap(null));
    Map.removePoligons('neighborhood');
  };
};

const buildCoordinates = () => {
  const isPoligonOnMap = Map.PoligonOnMap && Map.PoligonOnMap.getMap() !== null;
  const isCircleOnMap =
    (Map.markerCircle && Map.markerCircle.getMap() !== null) || false;

  if (isPoligonOnMap) {
    const coordinates =
      isPoligonOnMap &&
      Map.poligonCoordinates().map((coord) => [coord.lat(), coord.lng()]);
    return { coordinates };
  }
  if (isCircleOnMap) {
    const markerPosition = isCircleOnMap ? Map.markerCircle.center : undefined;
    const radius = isCircleOnMap ? Map.circleRadius : undefined;
    const coordinates = [markerPosition.lat(), markerPosition.lng()];
    return { coordinates, radius };
  }
};

export const searchRealtyOffers = (filters) => {
  const coords = buildCoordinates();
  return (dispatch) => {
    if (!coords) {
      dispatch(AddAlert('error', 'Selecione uma área no mapa'));
    }
    const payload = {
      location: coords,
      filters,
    };
  };
};

export const listAddress = (e) => {
  return (dispatch) => {
    Map.geocoder.geocode(
      {
        address: `${e.address}, ${e.city.Nome} - ${e.city.uf}`,
        region: 'BR',
      },
      (suggestion, status) => {
        if (status === 'OK' && suggestion) {
          const regex = new RegExp(/,+\s+[0-9]+\s+-/);
          const response = suggestion.filter((suggested) =>
            regex.test(suggested.formatted_address)
          );
          dispatch(setAddress(response));
        }
      }
    );
  };
};

export const setMapCenter = (user) => {
  const centerMap = setInterval(() => {
    const google = window.google;
    let flag = false;
    if (Map.map !== undefined) {
      const { start_coordinate: startCoordinate } = user;
      const { latitude, longitude } = startCoordinate;
      const coords = new google.maps.LatLng(latitude, longitude);
      Map?.map?.setCenter(coords);
      flag = true;
    }
    if (flag) {
      clearTimeout(centerMap);
    }
  }, 500);
};

const { IdToken } = sessionStorage;
export const searchAddressOnMap = (e, pinToErase) => {
  return (dispatch) => {
    dispatch(erasePin(pinToErase));
    const center = coordinatesBuilder([e]);
    const google = window.google;

    const address = buildAddress(e);
    const full = {
      location_coordinates: [center.lng, center.lat],
      number: address.number,
      postal_code: address.postalCode,
      street: address.street?.toUpperCase(),

      location: [center.lng, center.lat],
      tolken: IdToken,
    };

    Map.map.setCenter(center);
    Map.map.setZoom(15);

    Map.marker?.setMap(null);
    Map.markCircleOnMap({ center });
    const pin = new google.maps.Marker({
      position: center,
      map: Map.map,
      icon: Pin,
    });
    dispatch(addPin(pin));
  };

  // Map.markOnMap({ center, shouldBeDot: true });
};

export const coordinatesBuilder = (e) => {
  const coordinates = {
    lat: e?.[0]?.geometry?.location?.lat(),
    lng: e?.[0]?.geometry?.location?.lng(),
  };

  return coordinates;
};

export const buildAddress = ({ address_components }) => {
  const address = {};
  address_components?.forEach((address_components) => {
    if (address_components.types.includes('route'))
      address.street = address_components.long_name;

    if (address_components.types.includes('street_number')) {
      address.number = address_components.long_name;
    }

    if (address_components.types.includes('sublocality')) {
      address.neighborhood = address_components.long_name;
    }

    if (address_components.types.includes('administrative_area_level_2')) {
      address_components.city = address_components.long_name;
    }

    if (address_components.types.includes('administrative_area_level_1')) {
      address.uf = address_components.long_name;
    }

    if (address_components.types.includes('country')) {
      address.country = address_components.long_name;
    }

    if (address_components.types.includes('postal_code')) {
      address.postalCode = address_components.long_name;
    }
  });
  return address;
};

export const NEW_ALERT_NAME = 'NEW_ALERT_NAME';
export const setAlertName = (e) => ({
  type: NEW_ALERT_NAME,
  payload: e,
});

export const SET_IS_LOADING_MAP = 'SET_IS_LOADING_MAP';
export const setIsLoadingMap = (e) => ({
  type: SET_IS_LOADING_MAP,
  payload: e,
});

// export const setIsLoadingMap = () => {
//   return dispatch => {
//     Map.map.setOptions({draggableCursor:'wait'})
//   }
// }

// export const setIsLoadedMap = () => {
//   return dispatch => {
//     Map.map.setOptions({draggableCursor:'default'})

//   }
// }
